import React from 'react';
import { FUND_GRAPH_DATE } from '../../utils/testing/TestIDs';
import { TimeFrameContainer, TimeFrameLabel, TimeFrameMarker } from './styled-components';
export var ChartSelect = function ChartSelect(_ref) {
  var options = _ref.options,
      selectHandler = _ref.selectHandler,
      selectedIndex = _ref.selectedIndex;
  return /*#__PURE__*/React.createElement(TimeFrameContainer, null, /*#__PURE__*/React.createElement(TimeFrameMarker, {
    offset: selectedIndex,
    widthDivisor: options.length
  }), options.map(function (_ref2) {
    var id = _ref2.id,
        text = _ref2.text;
    return /*#__PURE__*/React.createElement(TimeFrameLabel, {
      key: id,
      onClick: function onClick() {
        return selectHandler(id);
      },
      "data-testid": FUND_GRAPH_DATE + text
    }, text);
  }));
};